import { getAppData } from 'optinmonster-js-library/src/vue/utils';

export const defaultState = () => ({
	analytics: {
		impressions: 0,
		conversions: 0,
		rate: 0.0,
	},
	topCampaigns: [],
	dateRange: {
		preset: true,
		filter: '30-days',
		start: '',
		end: '',
	},
	dismissedWelcomeBack: false,
	dismissedProUpsell: false,
	dismissedGrowthUpsell: false,
	minDate: '2019-04-10',
	announcements: [],
	onboardingPlugins: getAppData('onboardingPlugins', []),
});

const state = defaultState();

export const dismissKeys = Object.keys(state).filter((k) => 'dismissed' === k.substring(0, 9));

export default state;
